import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import DataTable from '../../components/common/DataTable';
import Badge from '../../components/common/Badge';
import { bizuApi } from '../../api/bizu.api';
import { getBizuImageUrl } from '../../utils/images';

const getColumns = (cacheKey) => [
  {
    key: 'image',
    label: 'Image',
    render: (row) => {
      const imageUrl = getBizuImageUrl(row.name);
      return (
        <div className="h-12 w-12 rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
          {imageUrl ? (
            <img
              src={`${imageUrl}?t=${cacheKey}`}
              alt={row.name}
              className="h-full w-full object-cover"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'flex';
              }}
            />
          ) : null}
          <span className={`text-gray-400 text-xs ${imageUrl ? 'hidden' : 'flex'} items-center justify-center h-full w-full`}>
            No image
          </span>
        </div>
      );
    }
  },
  {
    key: 'name',
    label: 'Name',
    render: (row) => (
      <div className="flex items-center gap-2">
        <div
          className="w-4 h-4 rounded-full"
          style={{ backgroundColor: row.color }}
        />
        <span className="font-medium">{row.name}</span>
      </div>
    )
  },
  { key: 'displayName', label: 'Display Name (EN)' },
  { key: 'displayName_es', label: 'Display Name (ES)' },
  {
    key: 'color',
    label: 'Color',
    render: (row) => (
      <div className="flex items-center gap-2">
        <div
          className="w-6 h-6 rounded border"
          style={{ backgroundColor: row.color }}
        />
        <span className="text-xs font-mono">{row.color}</span>
      </div>
    )
  },
  {
    key: 'isActive',
    label: 'Status',
    render: (row) =>
      row.isActive ? (
        <Badge variant="success">Active</Badge>
      ) : (
        <Badge variant="secondary">Inactive</Badge>
      )
  }
];

export default function BizuListPage() {
  const navigate = useNavigate();
  const [bizus, setBizus] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageCacheKey] = useState(Date.now());

  const fetchBizus = async () => {
    setLoading(true);
    try {
      const response = await bizuApi.getAll();
      setBizus(response.data.data);
    } catch (error) {
      console.error('Error fetching bizus:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBizus();
  }, []);

  return (
    <DashboardLayout>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Bizu Characters</h1>
      </div>

      <DataTable
        columns={getColumns(imageCacheKey)}
        data={bizus}
        loading={loading}
        onRowClick={(row) => navigate(`/bizu/${row.name}`)}
      />
    </DashboardLayout>
  );
}
